import { HTTP as http } from "../../http";

const PREFIX = "/delivery-times/";

export default {
    getCalendar: data => {
        return http.post(PREFIX + "getCalendar", data);
    },

    getDeliveryTimes: data => {
        return http.post(PREFIX + "getDeliveryTimes", data);
    },

    setSessionDeliveryTime: data => {
        return http.post(PREFIX + "setSessionDeliveryTime", data);
    },

    getSessionDeliveryTime: () => {
        return http.get(PREFIX + "getSessionDeliveryTime");
    }
};
